module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"account":"Account"}}')
  delete Component.options._Ctor
}
